// 支払済で、譲渡や払い戻しが可能かどうか
export const checkIsMovable = (book) => {
  return (book.is_paid && book.transfer_status != "unmovable");
}